import React, { useEffect } from "react";

import { SETTINGS_TIMERANGE_KEY } from "@constants";
import { useOrg } from "@hooks/useOrg";
import { TimeLookbackRange } from "@types";
import { recoverBrowserSecurityError } from "@utils/storage";

interface ITLRContext {
  tlr: string;
  setTlr: (tlr: string) => void;
}
export const TimeLookbackContext = React.createContext<ITLRContext>({
  tlr: "",
  setTlr: () => {
    throw new Error("TimeLookbackContext not initialized");
  },
});

export const TimeLookbackProvider: React.FC = ({ children }) => {
  const org = useOrg();
  const key = `${SETTINGS_TIMERANGE_KEY}-${org?.id}`;

  const timeLookbackFromLocalStorage = recoverBrowserSecurityError(() => {
    return localStorage.getItem(key);
  });
  // If the user doesn't have a TLR set, use the default
  if (org && !timeLookbackFromLocalStorage) {
    recoverBrowserSecurityError(() => localStorage.setItem(key, "1 month"));
  }
  // uses localStorage to initialize timeLookbackRange state
  const [tlr, setTlrLocal] = React.useState<string>("");

  useEffect(() => {
    if (org && tlr === "") {
      setTlrLocal(timeLookbackFromLocalStorage || "1 month");
    }
  }, [org, tlr, timeLookbackFromLocalStorage]);

  const setTlr = (newValue: TimeLookbackRange) => {
    recoverBrowserSecurityError(() => localStorage.setItem(key, newValue));
    setTlrLocal(newValue);
  };

  return (
    <TimeLookbackContext.Provider value={{ tlr, setTlr }}>
      {children}
    </TimeLookbackContext.Provider>
  );
};
